import { type Plugin } from 'vue';
import { VueQueryPlugin } from '@tanstack/vue-query';

export const setupTanstack: () => Plugin = () => VueQueryPlugin;